// let description: string;
// tslint:disable-next-line: max-line-length
const description = 'Hi I\'m Johnathn Deo,has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type.';

const teamData = [
    {
        admin: true,
        user: 'assets/images/users/avatar-3.jpg',
        name: 'Freddie J. Plourde',
        designation: '@Founder',
        website: 'websitename.com',
        description,
        icon: ['mdi mdi-facebook', 'mdi mdi-google', 'mdi mdi-github-circle']
    },
    {
        user: 'assets/images/users/avatar-4.jpg',
        name: 'Christopher Gallardo',
        designation: '@Webdesigner',
        website: 'abcweb.com',
        description,
        icon: ['mdi mdi-facebook', 'mdi mdi-twitter', 'mdi mdi-github-circle']
    },
    {
        user: 'assets/images/users/avatar-5.jpg',
        name: 'Joseph M. Rohr',
        designation: '@Webdesigner',
        website: 'mywebs.com',
        description,
        icon: ['mdi mdi-google', 'mdi mdi-twitter', 'mdi mdi-github-circle']
    },
    {
        user: 'assets/images/users/avatar-6.jpg',
        name: 'Mark K. Horne',
        designation: '@Director',
        website: 'profileq.com',
        description,
        icon: ['mdi mdi-facebook', 'mdi mdi-google', 'mdi mdi-twitter', 'mdi mdi-github-circle']
    },
    {
        user: 'assets/images/users/avatar-7.jpg',
        name: 'James M. Fonville',
        designation: '@Manager',
        website: 'coolweb.com',
        description,
        icon: ['mdi mdi-facebook', 'mdi mdi-google', 'mdi mdi-twitter']
    },
    {
        user: 'assets/images/users/avatar-8.jpg',
        name: 'Jade M. Walker',
        designation: '@Programmer',
        website: 'supported.com',
        description,
        icon: ['mdi mdi-facebook', 'mdi mdi-twitter', 'mdi mdi-github-circle']
    },
    {
        user: 'assets/images/users/avatar-2.jpg',
        name: 'Marie E. Tate',
        designation: '@Webdeveloper',
        website: 'website.com',
        description,
        icon: ['mdi mdi-facebook', 'mdi mdi-google', 'mdi mdi-github-circle']
    },
    {
        user: 'assets/images/users/avatar-9.jpg',
        name: 'Elyse D. Davidson',
        designation: '@Webdesigner',
        website: 'dumosite.com',
        description,
        icon: ['mdi mdi-facebook', 'mdi mdi-google']
    },
    {
        user: 'assets/images/users/avatar-10.jpg',
        name: 'Sarah E. Goin',
        designation: '@Manager',
        website: 'webion.com',
        description,
        icon: ['mdi mdi-facebook', 'mdi mdi-google', 'mdi mdi-twitter', 'mdi mdi-github-circle']
    }
];

export { teamData, description };

